// The look picker (MoET review, 21 Oct 2026: "too plain, does not feel like the ECONIC deck"): Classic · Signature · Aurora as one
// segmented control, each option a small swatch of its look (looks.css) and its name. In the account panel and Accessibility and display
// it writes the person's `pref:ui.look`; on the sign-in page (`value`/`onChange` given) it sets this device's look only. WP-SHELL.
import { useTranslation } from "@ncp/i18n";
import { LOOKS, type Look } from "../theme";
import { SegmentedControl } from "../theme/primitives";
import { useDisplaySettings } from "../prefs";

export function LookOptions(t: (k: string) => string) {
  return LOOKS.map((l) => ({
    value: l,
    label: (
      <span className="ec-look-opt">
        <i className="sw" data-swatch={l} aria-hidden />
        <span>{t(`assistant:econic.shell.look.${l}`)}</span>
      </span>
    ),
    ariaLabel: t(`assistant:econic.shell.look.${l}`),
  }));
}

/** The control alone, for a surface that holds the value itself (the sign-in page). */
export function LookControl({ value, onChange }: { value: Look; onChange: (l: Look) => void }) {
  const { t } = useTranslation();
  return <SegmentedControl<Look> label={t("assistant:econic.shell.look.title")} value={value} onChange={onChange} options={LookOptions(t)} />;
}

/** The row of the account panel and of Accessibility and display: the person's saved look. */
export function LookRow() {
  const { t } = useTranslation();
  const { look, setLook } = useDisplaySettings();
  return (
    <div className="row3" data-econic-look="">
      <span className="lb">{t("assistant:econic.shell.look.title")}</span>
      <LookControl value={look} onChange={setLook} />
    </div>
  );
}
